import React, { useEffect, useLayoutEffect, useRef } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { MapContainer, TileLayer, useMapEvents } from 'react-leaflet';
import ChangeView from '../ui/map_changeView';
import L from 'leaflet';
import HeatmapOverlay from 'heatmap.js/plugins/leaflet-heatmap/leaflet-heatmap.js';
import HeatmapLayer from './heatmap-component';
import Card from '../ui/card';
import { setMapBounds } from '../../redux/traffic-statistic';
var t = i18n.getFixedT(null, 'traffic-statistic');
var HeatMap = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$envCfg = _useSelector.envCfg,
      gisMapServiceApiUrl = _useSelector$envCfg.gisMapServiceApiUrl,
      gisMapZoomLevelMax = _useSelector$envCfg.gisMapZoomLevelMax,
      gisMapZoomLevelMin = _useSelector$envCfg.gisMapZoomLevelMin,
      gisMapInitViewportCenter = _useSelector$envCfg.gisMapInitViewportCenter,
      gisMapInitViewportZoom = _useSelector$envCfg.gisMapInitViewportZoom;

  var dispatch = useDispatch();

  var _mapRef = useRef();

  var hanldeMapCenterFormat = function hanldeMapCenterFormat(center) {
    if (_.isEmpty(center)) return {
      lat: 0,
      lng: 0
    };
    var latlngAry = center.split(', ');
    return {
      lat: latlngAry[1],
      lng: latlngAry[0]
    };
  };

  var handleRefreshMap = function handleRefreshMap() {
    setTimeout(function () {
      _mapRef.current.invalidateSize();
    }, 400);
  };

  if (!gisMapServiceApiUrl) return null;

  var MapEvent = function MapEvent() {
    var map = useMapEvents({
      zoomlevelschange: function zoomlevelschange(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      },
      moveend: function moveend(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      }
    });
    return null;
  };

  return /*#__PURE__*/React.createElement(Card, {
    className: "heatMap",
    title: t('lbl-congestion-traffic-statistic'),
    enableFullScreen: true,
    onFullScreenEvent: function onFullScreenEvent() {
      handleRefreshMap();
    }
  }, !_.isEmpty(gisMapServiceApiUrl) && /*#__PURE__*/React.createElement(MapContainer, {
    whenCreated: function whenCreated(mapInstance) {
      _mapRef.current = mapInstance;
      setTimeout(function () {
        mapInstance.invalidateSize();
      }, 250);
    },
    id: "heatmap-map",
    center: hanldeMapCenterFormat(gisMapInitViewportCenter),
    zoom: gisMapInitViewportZoom,
    zoomControl: false,
    attributionControl: false
  }, /*#__PURE__*/React.createElement(MapEvent, null), /*#__PURE__*/React.createElement(TileLayer, {
    url: gisMapServiceApiUrl,
    maxZoom: gisMapZoomLevelMax,
    minZoom: gisMapZoomLevelMin,
    crossOrigin: true
  }), /*#__PURE__*/React.createElement(HeatmapLayer, null)));
});
export default HeatMap;